module.exports = __webpack_public_path__ + "img/logoCMPWhite.770e70d8.png";